import { initContract } from '@ts-rest/core';
import { articleRoutes } from './articles.contract';

const c = initContract();

export const adminArticlesContract = c.router({
  getArticles: { ...articleRoutes.getArticles, path: '/admin/articles' },
  getArticleBySlug: { ...articleRoutes.getArticleBySlug, path: '/admin/articles/details/:slug' },
  getArticleById: { ...articleRoutes.getArticleById, path: '/admin/articles/:article_id' },
  createArticle: { ...articleRoutes.createArticle, path: '/admin/articles' },
  updateArticle: { ...articleRoutes.updateArticle, path: '/admin/articles/:article_id' },
  incrementArticleView: {
    ...articleRoutes.incrementArticleView,
    path: '/admin/articles/:article_id/increment-view',
  },
  deleteArticle: { ...articleRoutes.deleteArticle, path: '/admin/articles/:article_id' },
});
